import site from '../../extends/site';
const defaultSite = {
    title: 'BMW',
    logo: require('@/assets/images/bmlogo.png'),
};
const mix = Object.assign({}, defaultSite, site);
export default mix;
